import React from 'react';
import { ArrowLeftRight } from 'lucide-react';
import { Button, RobbieMark } from '../ui';
import { SpecSuggestion as Suggestion } from './specChipModel';

/**
 * Robbie's one line about the line's spec, when another spec would serve it
 * better (specSuggestionOf decides). The switch is the buyer's: Robbie only
 * offers the button.
 */
interface SpecSuggestionProps {
  suggestion: Suggestion;
  /** Absent (view-only) → the sentence alone. */
  onSwitch?: (specGroup: string) => void;
  switching?: string | null;
}

export const SpecSuggestion: React.FC<SpecSuggestionProps> = ({ suggestion, onSwitch, switching = null }) => (
  <div className="flex shrink-0 flex-wrap items-center gap-x-s3 gap-y-s2 rounded-card border border-robbie-border bg-ai-panel px-s4 py-[9px]">
    <RobbieMark size="xs" state="insight" aria-label="Robbie" className="shrink-0" />
    <p className="m-0 min-w-0 flex-1 basis-[220px] text-body-sm text-robbie-ink">{suggestion.sentence}</p>
    {onSwitch && (
      <Button
        variant="secondary"
        size="sm"
        iconLeft={<ArrowLeftRight />}
        loading={switching === suggestion.specGroup}
        loadingLabel="Switching…"
        disabled={Boolean(switching)}
        onClick={() => onSwitch(suggestion.specGroup)}
      >
        Switch to {suggestion.label}
      </Button>
    )}
  </div>
);

export default SpecSuggestion;
